import { getChatApiRoute } from '@shared/utils/ChatBackendUtils'

export async function deleteInsights(token: string, insightIds: string[]) {
  const url = getChatApiRoute('api/v1/insights')

  const response = await fetch(url, {
    method: 'DELETE',
    body: JSON.stringify(insightIds),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to delete insights: ${response.status} ${response.statusText}`)
  }

  return response.ok
}
